import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { getAccountActivityRuleErrors } from '../../../../../components/InputField/helper';
import { WrapperField } from '../../../../../components/InputField/WrapperField';
import { setValue } from '../../../../../components/InputField/helper';
import { DialogContext } from '../../../../../store/context/DialogContext';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import ButtonGroupNew from '../../BusinessLiteForms/components/ButtonGroupNew';
import { WIZARD, WIZARD_NUM, getNextStep, getVisibleWizardFieldOrder, shouldShowRegionalFields } from '../helper';
import { FORM_TYPE } from '../../IPlushelper';

const BusinessActivity = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    isForEDD,
    handleChange,
    handlePrev,
    setData,
    applicationForm,
    editMode,
}) => {
    const { showError } = useContext(DialogContext);
    const { t } = useTranslation();

    const checkNext = () => {
        const visibleFieldOrder = getVisibleWizardFieldOrder({
            fields: iPlusFields,
            wizard,
            data,
        });

        for (const fieldPath of visibleFieldOrder) {
            const fieldError = _.get(errors, fieldPath);
            if (fieldError) {
                setHasError(true);
                if (fieldError) {
                    showError(fieldError);
                    return false;
                }
            }
        }

        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: getNextStep(wizard, applicationForm, data, editMode) });
        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    };

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            updatedErrors[field] = errorMsg;
            return updatedErrors;
        });
    };

    const setConversionValues = (type, sourceData = data) => {
        if (type === "Stablecoin") {
            let updatedData = { ...(sourceData ?? {}) };

            // Use setValue to properly track diffMap changes
            updatedData = setValue(updatedData, 'Number_Of_Monthly_Stablecoin_Conversions_Deposits', 0, isForEDD, sourceData?.selfDeclaredValues?.Number_Of_Monthly_Stablecoin_Conversions_Deposits ?? "");
            updatedData = setValue(updatedData, 'Amount_Of_Monthly_Stablecoin_Conversions_Deposits', 0, isForEDD, sourceData?.selfDeclaredValues?.Amount_Of_Monthly_Stablecoin_Conversions_Deposits ?? "");
            updatedData = setValue(updatedData, 'Number_Of_Monthly_Stablecoin_Conversions_Payments', 0, isForEDD, sourceData?.selfDeclaredValues?.Number_Of_Monthly_Stablecoin_Conversions_Payments ?? "");
            updatedData = setValue(updatedData, 'Amount_Of_Monthly_Stablecoin_Conversions_Payments', 0, isForEDD, sourceData?.selfDeclaredValues?.Amount_Of_Monthly_Stablecoin_Conversions_Payments ?? "");

            return updatedData;
        }

        if (type === "Cryptocurrency") {
            let updatedData = { ...(sourceData ?? {}) };

            // Use setValue to properly track diffMap changes
            updatedData = setValue(updatedData, 'Count_Of_Monthly_Cryptocurrency_Conversions', 0, isForEDD, sourceData?.selfDeclaredValues?.Count_Of_Monthly_Cryptocurrency_Conversions ?? "");
            updatedData = setValue(updatedData, 'Amount_Of_Monthly_Cryptocurrency_Conversions', 0, isForEDD, sourceData?.selfDeclaredValues?.Amount_Of_Monthly_Cryptocurrency_Conversions ?? "");

            return updatedData;
        }

        return sourceData;
    };

    const clearConversionValues = (type, sourceData = data) => {
        if (type === "Stablecoin") {
            let updatedData = { ...(sourceData ?? {}) };

            // Use setValue to properly track diffMap changes - clear to original values
            updatedData = setValue(updatedData, 'Number_Of_Monthly_Stablecoin_Conversions_Deposits', sourceData?.selfDeclaredValues?.Number_Of_Monthly_Stablecoin_Conversions_Deposits ?? "", isForEDD, "");
            updatedData = setValue(updatedData, 'Amount_Of_Monthly_Stablecoin_Conversions_Deposits', sourceData?.selfDeclaredValues?.Amount_Of_Monthly_Stablecoin_Conversions_Deposits ?? "", isForEDD, "");
            updatedData = setValue(updatedData, 'Number_Of_Monthly_Stablecoin_Conversions_Payments', sourceData?.selfDeclaredValues?.Number_Of_Monthly_Stablecoin_Conversions_Payments ?? "", isForEDD, "");
            updatedData = setValue(updatedData, 'Amount_Of_Monthly_Stablecoin_Conversions_Payments', sourceData?.selfDeclaredValues?.Amount_Of_Monthly_Stablecoin_Conversions_Payments ?? "", isForEDD, "");

            return updatedData;
        }

        if (type === "Cryptocurrency") {
            let updatedData = { ...(sourceData ?? {}) };

            // Use setValue to properly track diffMap changes - clear to original values
            updatedData = setValue(updatedData, 'Count_Of_Monthly_Cryptocurrency_Conversions', sourceData?.selfDeclaredValues?.Count_Of_Monthly_Cryptocurrency_Conversions ?? "", isForEDD, "");
            updatedData = setValue(updatedData, 'Amount_Of_Monthly_Cryptocurrency_Conversions', sourceData?.selfDeclaredValues?.Amount_Of_Monthly_Cryptocurrency_Conversions ?? "", isForEDD, "");

            return updatedData;
        }

        return sourceData;
    };

    return (
        <div className="row">
            <div className="col-12">
                <h2 style={{ fontWeight: 'bolder' }} className='pt-3 mb-4'>Business Activity</h2>

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["Primary_Business_Activities"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('Primary_Business_Activities', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["Business_Product_Services"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('Business_Product_Services', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["Customer_Description"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('Customer_Description', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["Illegal_Immoral_Disclosure"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('Illegal_Immoral_Disclosure', errorMsg)}
                    isForEDD={isForEDD}
                />

                <h3 style={{ fontWeight: 'bolder' }} className='pt-4 mb-3'>Expected Bank Account Activity</h3>

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["Deposit_Reasons"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('Deposit_Reasons', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["Payment_Reasons"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('Payment_Reasons', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["Deposit_Locations"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('Deposit_Locations', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["Payment_Locations"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('Payment_Locations', errorMsg)}
                    isForEDD={isForEDD}
                />

                {/* Crypto conversion questions (Business version) */}

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["hasCoinConversionPlan"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('hasCoinConversionPlan', errorMsg)}
                    isForEDD={isForEDD}
                    customOperator={(v, nextData) => {
                        if (v === false)
                            handleUpdateFormData(setConversionValues("Stablecoin", nextData))
                        else if (v === true)
                            handleUpdateFormData(clearConversionValues("Stablecoin", nextData));
                    }}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["hasCryptoConversionPlan"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('hasCryptoConversionPlan', errorMsg)}
                    isForEDD={isForEDD}
                    customOperator={(v, nextData) => {
                        if (v === false)
                            handleUpdateFormData(setConversionValues("Cryptocurrency", nextData));
                        else if (v === true)
                            handleUpdateFormData(clearConversionValues("Cryptocurrency", nextData));
                    }}
                />

                {/* BusinessPrime specific regional questions */}
                {shouldShowRegionalFields(applicationForm) && (
                    <>
                        <h3 style={{ fontWeight: 'bolder' }} className='pt-4 mb-3'>Regional Interactions</h3>

                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["Interaction_With_South_American_Countries"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('Interaction_With_South_American_Countries', errorMsg)}
                            isForEDD={isForEDD}
                        />

                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["Interaction_With_Central_American_Countries"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('Interaction_With_Central_American_Countries', errorMsg)}
                            isForEDD={isForEDD}
                        />

                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["Interaction_With_Caribbean_Countries"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('Interaction_With_Caribbean_Countries', errorMsg)}
                            isForEDD={isForEDD}
                        />

                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["caribbeanCountriesOther"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('caribbeanCountriesOther', errorMsg)}
                            isForEDD={isForEDD}
                        />


                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["paymentForms"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('paymentForms', errorMsg)}
                            isForEDD={isForEDD}
                        />


                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["internationalCustomers"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('internationalCustomers', errorMsg)}
                            isForEDD={isForEDD}
                        />


                    </>
                )}

                <div className='mt-4'>
                    <ButtonGroupNew
                        onNextClick={handleSubmit}
                        onBackClick={() => { handlePrev() }}
                        step={WIZARD_NUM.BusinessActivity}
                        showPageNum={false}
                        pageNum={WIZARD_NUM.BusinessActivity}
                        hideSubmitButton={hideButtons}
                        asLabel={false}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default observer(BusinessActivity);
